// redux/slices/pdfSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPresignedUrlDocApi } from "../../apis/scheduleAndTimetable";

// Async thunk - accepts an object with docId and docType
export const getUrlForPDF = createAsyncThunk(
  "pdfs/get",
  async ({ docId, docType }, thunkAPI) => {
    try {
      const response = await getPresignedUrlDocApi(docId, docType);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pdfSlice = createSlice({
  name: "pdfs",
  initialState: {
    pdfs: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUrlForPDF.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getUrlForPDF.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.url = action.payload;
      })
      .addCase(getUrlForPDF.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default pdfSlice.reducer;
